import { PlatformPortal } from './PlatformPortal.jsx';

// بوابة مدير النظام — ليست جزءاً من نظام الشركة:
// standalone حتى تُعرض خارج Shell (لا شريط جانبي)، protected:false لأن
// الحماية من جلسة مدير النظام نفسها (حارس داخل PlatformPortal).
export default {
  path: '/platform/*',
  element: <PlatformPortal />,
  protected: false,
  permission: null,
  standalone: true,
  sidebar: null
};
